import * as RoutePathConstants from '../../../../constants/RoutePathConstants'
import myRecordTable from '../my-record/views/my-record-table'
import couponInfoDetail from '../my-record/views/coupon-info-detail'

export default [
  {
    path: RoutePathConstants.GO_OUT_MY_RECORD,
    name: 'myRecordTable',
    component: myRecordTable
  },
  {
    path: RoutePathConstants.GO_OUT_COUPON_INFO_DETAIL,
    name: 'couponInfoDetail',
    component: couponInfoDetail
  }
]



// WEBPACK FOOTER //
// ./src/pages/wx-member/go-out-management/my-record/routers.js